import { useContext } from 'react';
import UserContext, { UserContextType } from '../contexts/UserContext';

/**
 * Hook that provides type-safe access to the user context.
 * This hook should be used within components that need access to the current user or socket.
 * Must be used within a component that is a child of UserProvider.
 *
 * @returns The user context containing the current user and socket.
 * @throws Error if used outside of a UserProvider.
 */
const useUserContext = (): UserContextType => {
  const context = useContext(UserContext);

  if (context === null) {
    throw new Error('useUserContext must be used within a UserProvider');
  }

  return context;
};

export default useUserContext;
